import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export default function SelectMenu({ label, value, options, callback, size = "medium" }) {
   const handleChange = (event) => {
      callback(event.target.value);
   };

   return (
      <Box sx={{ width: size === "small" ? 200 : 300 }}>
         <FormControl fullWidth size={size}>
            <InputLabel>{label}</InputLabel>
            <Select
               value={value}
               label={label}
               onChange={handleChange}
               defaultValue={options[1]}
            >
               {options.map((option, index) => (
                  <MenuItem key={index} value={option}>{option}</MenuItem>
               ))}
            </Select>
         </FormControl>
      </Box>
   );
}
